import React, { Component } from "react";
import { bool, func, string } from "prop-types";
import { Link } from "react-router-dom";

import I18n from "pages/_components/I18n";
import Image from "pages/_components/Image";
import classNames from "classnames";

class SettingsOption extends Component {
    static propTypes = {
        linkTo: string.isRequired,
        messageKey: string.isRequired,
        onClick: func,
        isMobile: bool,
    };

    static defaultProps = {
        isMobile: false,
        onClick: null,
    };

    render() {
        const { linkTo, messageKey, isMobile, onClick } = this.props;

        return (
            <li className={classNames("navigational-list-item mb-2", { "b-none": isMobile })}>
                <Link to={linkTo} onClick={onClick}>
                    <I18n id={messageKey} />
                    <Image src="images/chevromRight.svg" className="svg-icon svg-caret" />
                </Link>
            </li>
        );
    }
}

export default SettingsOption;
